import React from 'react';
import PropTypes from 'prop-types';

import { Image } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleSingleImage = ({
    image = {},
    caption,
    layout = 'Trunk',
    nextTypename,
    parentTypename
}) => {
    if (!image) { return null; }

    if (layout === 'Wide' || parentTypename === 'BvaModuleAccordion') {
        return (
            <div className='relative bg-white'>
                <div className={`${parentTypename === 'BvaModuleAccordion' ? '' : 'layout-container'} relative bg-white`}>
                    <figure className={`module-single-image ${parentTypename === 'BvaModuleAccordion' ? '' : 'px-10 sm:px-5 md:px-10'}`}>
                        {image?.contentType?.includes('video/') ? (
                            <video
                                autoPlay
                                loop
                                muted
                                playsInline
                                src={image?.src}
                                width={'100%'}/>
                        ) : <Image
                            loadWidth={1440}
                            {...image} />
                        }
                        {!!caption &&
                            <figcaption className={`${nextTypename === 'BvaModuleText' && 'md:absolute '}w-full sm:w-4/6 md:w-4/12 type-style-7 text-dark-grey whitespace-pre-wrap mt-20 sm:mt-15`}>
                                {caption}
                            </figcaption>
                        }
                    </figure>
                </div>
            </div>
        );
    } else {
        return (
            <div className='relative bg-white'>
                <div className='layout-container'>
                    <figure className='module-single-image w-full flex flex-wrap md:flex-row-reverse'>
                        <div className='w-full md:w-10/12 px-10 sm:px-5 md:px-10'>
                            {image?.contentType?.includes('video/') ? (
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    src={image?.src}
                                    width={'100%'}/>
                            ) : <Image
                                loadWidth={1440}
                                {...image} />
                            }
                        </div>
                        {!!caption &&
                            <figcaption className={`${nextTypename === 'BvaModuleTwoImage' ? 'md:w-2/12 md:mt-0 ' : 'md:w-3/12 md:ml-w-2/12 md:mr-w-7/12'} w-full sm:w-4/6 type-style-7 text-dark-grey whitespace-pre-wrap mt-20 sm:mt-15 px-10`}>
                                {caption}
                            </figcaption>
                        }
                    </figure>
                </div>
            </div>
        );
    }
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

ModuleSingleImage.propTypes = {
    caption: PropTypes.string,
    image: PropTypes.shape({
        src: PropTypes.string.isRequired
    }).isRequired,
    layout: PropTypes.string,
    nextTypename: PropTypes.string,
    parentTypename: PropTypes.string,
};

export default ModuleSingleImage;
